import React, { Component, Fragment } from "react"
import { connect } from "react-redux"

import { dashboardInfoRequest } from "../../actions/dashboard-actions"

import MetricsContainer from "./MetricsContainer"
import KnowledgeSearch from "./knowledge-list/KnowledgeSearch"
import DashboardKnowledgeListWidgetContainer from "./knowledge-list/DashboardKnowledgeListWidgetContainer"
import FlowGraph from "./FlowGraph"
import InsightAreasCoverageGraph from "./InsightAreasCoverageGraph"

class Dashboard extends Component {
    componentDidMount() {
        this.props.requestInfo()
    }

    render() {
        return (
            <div
                id="dashboard-home"
                className="widgets-container full-container-height clearfix"
            >
                <MetricsContainer {...this.props.simpleMetrics} />
                <div
                    id="quick-search"
                    className="col-xl-4 col-xs-12 col-md-6 widget-bottom-margin"
                >
                    <KnowledgeSearch />
                </div>
                <div className="col-xs-12 col-md-6 col-xl-4 feeds-list widget-bottom-margin">
                    <DashboardKnowledgeListWidgetContainer />
                </div>
                <div
                    id="knowledge-graph-container"
                    className="col-xs-12 col-md-6 col-xl-4 widget-bottom-margin"
                >
                    <FlowGraph
                        flow={this.props.flow}
                        shortXAxis={true}
                        animationDelay={1000}
                        isFetching={!this.props.flow}
                        renderHeader={() => (
                            <Fragment>
                                <span className="icon icon-knowledge-flow" />
                                Knowledge flow
                            </Fragment>
                        )}
                    />
                </div>
                <div
                    id="insight-areas-container"
                    className="col-xs-12 col-xl-4 widget-bottom-margin"
                >
                    <InsightAreasCoverageGraph coverage={this.props.coverage} />
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    ...state.entities.dashboardInfo.data,
})

const mapDispatchToProps = (dispatch) => ({
    requestInfo: () => dispatch(dashboardInfoRequest()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)
